let config = {
  BASEURL: process.env.VUE_APP_BASE_URL
}

export default config
